import React, { useEffect } from 'react'
import '../styles/tunnel.css'

/**
 * Wrapper appliqué à toutes les pages du tunnel de commande.
 * - Positionne data-tunnel="light" sur <html> pour forcer le fond de page blanc
 * - Applique la classe .tunnel-light au container pour surcharger
 *   tous les styles sombres (cards, boutons, formulaires, stepper…)
 */
const TunnelLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    document.documentElement.setAttribute('data-tunnel', 'light')
    return () => {
      document.documentElement.removeAttribute('data-tunnel')
    }
  }, [])

  return (
    <div className="tunnel-light" style={{ minHeight: '100%' }}>
      {children}
    </div>
  )
}

export default TunnelLayout
